export default {"src":"/_next/static/media/external-link.584bde94.svg","height":16,"width":15};